// This class contains form mapping logic for preneed agreement form
// getFormMappings() would return an array of FoxIt fields with the corresponding value
import { FormMapping } from './FormMapping'
import { PdfCheckboxValue } from '@/enums/PdfCheckboxValue'
import { Term, type ScenarioOutput } from '@precoa/calculator-sdk'

export default class PreneedAgreementForm extends FormMapping {
	private readonly enrollmentPaymentDetails: ScenarioOutput | undefined

	constructor(planHolderId: string, enrollmentPaymentDetails?: ScenarioOutput) {
		super(planHolderId)
		this.enrollmentPaymentDetails = enrollmentPaymentDetails
	}

	// Helper to fill in funeralTotal
	getFuneralAmtMapping() {
		if (!this.enrollmentPaymentDetails) return []
		const paymentDetails = this.enrollmentPaymentDetails
		const singlePay = this.planHolder.insurance.term === Term.SinglePay
		const dueTodayAmount = this.formatAmount(paymentDetails.totalDueTodayAmt)

		return [
			{
				name: 'funeralAmountTotal',
				value: this.formatAmount(paymentDetails.totalFaceAmt),
			},
			{
				name: 'payment1YesMACheck',
				value: singlePay
					? PdfCheckboxValue.Checked
					: PdfCheckboxValue.Unchecked,
			},
			{
				name: 'payment1FuneralTotal',
				value: singlePay ? dueTodayAmount : '',
			},
			{
				name: 'payment2YesMACheck',
				value: !singlePay
					? PdfCheckboxValue.Checked
					: PdfCheckboxValue.Unchecked,
			},
			{
				name: 'payment2FuneralDeposit',
				value: !singlePay ? dueTodayAmount : '',
			},
		]
	}

	getFormMappings() {
		return [
			...this.getProposedInsuredMapping(),
			...this.getPolicyOwnerMapping(),
			...this.getPolicyOwnerAddressMapping(),
			...this.getProposedInsuredAddressMapping(),
			...this.getFuneralHomeMapping(),
			...this.getFuneralHomeRepresentativeMappings(),
			...this.getFuneralAmtMapping(),
		]
	}
}
